import { Dialog } from '@common/overlay-manager';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const handleNetworkError = async (error: any, retry: () => Promise<void>) => {
  const connect_fail_message_list = [
    'Failed to fetch', // AOS
    'The Internet connection appears to be offline.', // IOS
    '인터넷 연결이 오프라인 상태입니다.',
  ];

  if (error.message && connect_fail_message_list.indexOf(error.message) >= 0) {
    if (
      (await Dialog.confirm({
        title: '네트워크 연결 오류',
        message: '네트워크 연결이 원활하지 않아요.\n다시 시도해주세요!',
        ok: '다시 시도',
      })) === 'ok'
    ) {
      await retry();
    }
    return true;
  }

  return false;
};
